import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import PageHeader from '../components/PageHeader';
import usePageSearchIndex from '../hooks/usePageSearchIndex';
import './Circulars.css';

const Circulars = () => {
  const { isMarathi } = useLanguage();

  usePageSearchIndex({
    mr: ['परिपत्रके', 'कर्मचाऱ्यांसाठी परिपत्रके', 'सूचना'],
    en: ['circulars', 'circulars for employees', 'notices']
  });

  const pageHeaderData = {
    title: {
      marathi: 'कर्मचाऱ्यांसाठी परिपत्रके',
      english: 'Circulars for Employees'
    },
    subtitle: {
      marathi: 'महाराष्ट्र कामगार कल्याण मंडळाची परिपत्रके आणि फॉर्म्स',
      english: 'Circulars and Forms of Maharashtra Labour Welfare Board'
    }
  };

    return (
    <div className="circulars-for-employees">
      <div className="circulars-for-employees-container">
      {/* Page Header */}
      <PageHeader 
        title={pageHeaderData.title}
        subtitle={pageHeaderData.subtitle}
      />

        {/* Main Content */}
        <div className="circulars-for-employees-content" data-read-section="circulars-content">
          {/* Circulars Table */}
          <section className="circulars-for-employees-section">
            <div className="circulars-for-employees-table-container">
              <table className="circulars-for-employees-table">
                <thead>
                  <tr>
                    <th>
                      {isMarathi() ? 'अनुक्रमांक' : 'Serial No.'}
                    </th>
                    <th>
                      {isMarathi() ? 'तपशील' : 'Details'}
                    </th>
                    <th>
                      {isMarathi() ? 'परिपत्रक' : 'Circular'}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="circular-for-employee-serial">
                      {isMarathi() ? '१' : '1'}
                    </td>
                    <td className="circular-for-employee-details">
                      {isMarathi() ? 'दि. ३० जून रोजी सेवानिवृत्त होणा-या कर्मचा-यांना लगतच्या दि.०१ जुलै रोजीची काल्पनिक वेतनवाढ देण्याबाबत' : 'Regarding granting notional increment on July 1st to employees retiring on June 30th.'}
                    </td>
                    <td className="circular-for-employee-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/circulars-for-employees/regarding-granting-notional-increment-on-July-1st-to-employees-retiring-on-June-30th.pdf" 
                        className="circular-for-employee-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="circular-for-employee-serial">
                      {isMarathi() ? '२' : '2'}
                    </td>
                    <td className="circular-for-employee-details">
                      {isMarathi() ? 'म.का.क.मंडळातील अधिकारी व कर्मचा-यांना वैयक्तिक संगणक खरेदी करण्यासाठी अग्रिम रक्कम मंजूर करणेबाबत' : 'Regarding sanctioning advance payment to officers and employees of the Maharashtra Labour Welfare Board for purchasing personal computers.'}
                    </td>
                    <td className="circular-for-employee-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/circulars-for-employees/regarding-sanctioning-advance-payment-to-officers-and-employees-of-the-maharashtra-labour-welfare-board-for-purchasing-personal-computers.pdf" 
                        className="circular-for-employee-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="circular-for-employee-serial">
                      {isMarathi() ? '३' : '3'}
                    </td>
                    <td className="circular-for-employee-details">
                      {isMarathi() ? 'मंडळातील अर्धवेळ कर्मचा-यांना विभागस्तरावर सेवामुक्त करण्याबाबत' : 'Regarding relieving part-time employees of the Board at the departmental level.'}
                    </td>
                    <td className="circular-for-employee-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/circulars-for-employees/regarding-relieving-part-time-employees-of-the-board-at-the-departmental-level.pdf" 
                        className="circular-for-employee-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="circular-for-employee-serial">
                      {isMarathi() ? '४' : '4'}
                    </td>
                    <td className="circular-for-employee-details">
                      {isMarathi() ? 'मत्ता व दायित्व विवरणपत्र सादर करण्याबाबत' : 'Regarding submission of asset and liability statements.'}
                    </td>
                    <td className="circular-for-employee-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/circulars-for-employees/regarding-submission-of-asset-and-liability-statements.pdf" 
                        className="circular-for-employee-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="circular-for-employee-serial">
                      {isMarathi() ? '५' : '5'}
                    </td>
                    <td className="circular-for-employee-details">
                      {isMarathi() ? 'रोजनिशी दैनंदिनी बाबत' : 'Regarding daily diary/logbook.'}
                    </td>
                    <td className="circular-for-employee-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/circulars-for-employees/regarding-daily-diary-logbook.pdf" 
                        className="circular-for-employee-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="circular-for-employee-serial">
                      {isMarathi() ? '६' : '6'}
                    </td>
                    <td className="circular-for-employee-details">
                      {isMarathi() ? 'वेतनश्रेणी कमाल टप्प्याच्या पुढे जात असेल' : 'If the pay scale exceeds the maximum stage.'}
                    </td>
                    <td className="circular-for-employee-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/circulars-for-employees/if-the-pay-scale-exceeds-the-maximum-stage.pdf" 
                        className="circular-for-employee-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="circular-for-employee-serial">
                      {isMarathi() ? '७' : '7'}
                    </td>
                    <td className="circular-for-employee-details">
                      {isMarathi() ? 'शासकीय वाहन चालकांना देण्यात येणा-या अतिकालिक भत्त्यामध्ये वाढीबाबत' : 'Regarding increase in overtime allowance given to government vehicle drivers.'}
                    </td>
                    <td className="circular-for-employee-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/circulars-for-employees/regarding-increase-in-overtime-allowance-given-to-government-vehicle-drivers.pdf" 
                        className="circular-for-employee-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="circular-for-employee-serial">
                      {isMarathi() ? '८' : '8'}
                    </td>
                    <td className="circular-for-employee-details">
                      {isMarathi() ? 'संघटनेच्या पदाधिकाऱ्याना विशेष नैमित्तिक रजा मंजुरीबाबत' : 'Regarding sanctioning special casual leave to office bearers of the organization.'}
                    </td>
                    <td className="circular-for-employee-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/circulars-for-employees/regarding-sanctioning-special-casual-leave-to-office-bearers-of-the-organization.pdf" 
                        className="circular-for-employee-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="circular-for-employee-serial">
                      {isMarathi() ? '९' : '9'}
                    </td>
                    <td className="circular-for-employee-details">
                      {isMarathi() ? 'सहायक कल्याण आयुक्त (संगणक) या प्रदान केलेले अधिकार' : 'Powers granted to the Assistant Welfare Commissioner (Computer).'}
                    </td>
                    <td className="circular-for-employee-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/circulars-for-employees/powers-granted-to-the-assistant-welfare-commissioner-computer.pdf" 
                        className="circular-for-employee-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="circular-for-employee-serial">
                      {isMarathi() ? '१०' : '10'}
                    </td>
                    <td className="circular-for-employee-details">
                      {isMarathi() ? 'सेवापुस्तिकेत नोंदीबाबत' : 'Regarding entries in the service book.'}
                    </td>
                    <td className="circular-for-employee-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/circulars-for-employees/regarding-entries-in-the-service-book.pdf" 
                        className="circular-for-employee-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="circular-for-employee-serial">
                      {isMarathi() ? '११' : '11'}
                    </td>
                    <td className="circular-for-employee-details">
                      {isMarathi() ? 'दि.३१.०३.२०१२ - मंडळातील विभागप्रमुख व गटप्रमुख यांना प्रदान केलेले वित्तीय अधिकार' : 'Dated 31.03.2012 - Financial powers granted to the Heads of Departments and Group Heads of the Board.'}
                    </td>
                    <td className="circular-for-employee-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/circulars-for-employees/dated-31.03.2012-financial-powers-granted-to-the-heads-of-departments-and-group-heads-of-the-board.pdf" 
                        className="circular-for-employee-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="circular-for-employee-serial">
                      {isMarathi() ? '१२' : '12'}
                    </td>
                    <td className="circular-for-employee-details">
                      {isMarathi() ? 'महाराष्ट्र लोकसेवा हक्क अधिनियम, २०१५ अंतर्गत म.का.क.मंडळाच्या सेवा अधिसूचित झालेबाबत' : 'Regarding notification of services of the Maharashtra Labour Welfare Board under the Maharashtra Public Services Right to Service Act, 2015.'}
                    </td>
                    <td className="circular-for-employee-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/circulars-for-employees/regarding-notification-of-services-of-the-maharashtra-labour-welfare-board-under-the-maharashtra-public-services-right-to-service-act-2015.pdf" 
                        className="circular-for-employee-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="circular-for-employee-serial">
                      {isMarathi() ? '१३' : '13'}
                    </td>
                    <td className="circular-for-employee-details">
                      {isMarathi() ? 'महाराष्ट्र कामगार कल्याण मंडळाचे अधिकार आणि कार्ये पार पाडण्यासाठी उप सचिव (कामगार-१०) यांच्या नियुक्तीबाबत' : 'Regarding the appointment of Deputy Secretary (Labour-10) to perform the powers and functions of the Maharashtra Labour Welfare Board.'}
                    </td>
                    <td className="circular-for-employee-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/circulars-for-employees/regarding-the-appointment-of-deputy-secretary-labour-10-to-perform-the-powers-and-functions-of-the-maharashtra-labour-welfare-board.pdf" 
                        className="circular-for-employee-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="circular-for-employee-serial">
                      {isMarathi() ? '१४' : '14'}
                    </td>
                    <td className="circular-for-employee-details">
                      {isMarathi() ? 'कार्यमूल्यमापन अहवाल लिहिणे व जतन करणेबाबत' : 'Regarding writing and preserving performance evaluation reports.'}
                    </td>
                    <td className="circular-for-employee-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/circulars-for-employees/regarding-writing-and-preserving-performance-evaluation-reports.pdf" 
                        className="circular-for-employee-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="circular-for-employee-serial">
                      {isMarathi() ? '१५' : '15'}
                    </td>
                    <td className="circular-for-employee-details">
                      {isMarathi() ? 'सुरक्षारक्षक नेमण्याबाबत परिपत्रक' : 'Circular regarding appointment of security guards.'}
                    </td>
                    <td className="circular-for-employee-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/circulars-for-employees/circular-regarding-appointment-of-security-guards.pdf" 
                        className="circular-for-employee-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="circular-for-employee-serial">
                      {isMarathi() ? '१६' : '16'}
                    </td>
                    <td className="circular-for-employee-details">
                      {isMarathi() ? 'परिपत्रक २८/०८/२०१८ ते २७/०८/२०१८' : 'Circular 28/08/2018 to 27/08/2018'}
                    </td>
                    <td className="circular-for-employee-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/circulars-for-employees/Mediclaim_2018_paripatrak_28.08.2018_27.08.2019.pdf" 
                        className="circular-for-employee-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="circular-for-employee-serial">
                      {isMarathi() ? '१७' : '17'}
                    </td>
                    <td className="circular-for-employee-details">
                      {isMarathi() ? 'दावा प्रक्रिया' : 'Claim process'}
                    </td>
                    <td className="circular-for-employee-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/circulars-for-employees/Mediclaim_2018_claim_process.pdf" 
                        className="circular-for-employee-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="circular-for-employee-serial">
                      {isMarathi() ? '१८' : '18'}
                    </td>
                    <td className="circular-for-employee-details">
                      {isMarathi() ? 'घोषणा पत्र' : 'Declaration form'}
                    </td>
                    <td className="circular-for-employee-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/circulars-for-employees/Mediclaim_2018_declaration_form.pdf" 
                        className="circular-for-employee-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="circular-for-employee-serial">
                      {isMarathi() ? '१९' : '19'}
                    </td>
                    <td className="circular-for-employee-details">
                      {isMarathi() ? 'आय.आर.डी.ए. दावा - फॉर्म' : 'IRDA Claim - Form'}
                    </td>
                    <td className="circular-for-employee-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/circulars-for-employees/Mediclaim_2018_IRDA_claim-form.pdf" 
                        className="circular-for-employee-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="circular-for-employee-serial">
                      {isMarathi() ? '२०' : '20'}
                    </td>
                    <td className="circular-for-employee-details">
                      {isMarathi() ? 'आय.आर.डी.ए. कॅशलेस फॉर्म' : 'IRDA Cashless Form'}
                    </td>
                    <td className="circular-for-employee-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/circulars-for-employees/Mediclaim_2018_IRDA_cashless_form.pdf" 
                        className="circular-for-employee-link" 
                target="_blank"
                rel="noopener noreferrer"
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Circulars;
